import loadable from 'helper/loadable'

const Login = loadable(() => import('js/view-plcp/page/login'))
const Home = loadable(() => import('js/view-plcp/page/home'))
const PLPrimaryStars = loadable(() => import('js/view-plcp/page/pl-primary-stars'))
const PLKicks = loadable(() => import('js/view-plcp/page/pl-kicks'))
const PLInspires = loadable(() => import('js/view-plcp/page/pl-inspires'))
const PLPfa = loadable(() => import('js/view-plcp/page/pl-pfa'))
const Facilities = loadable(() => import('js/view-plcp/page/facilities'))
const Funding = loadable(() => import('js/view-plcp/page/funding'))
// const AboutThePL = loadable(() => import('js/view-plcp/page/about-the-pl'))
const EconomicImpact = loadable(() => import('js/view-plcp/page/economic-impact'))

export {
  Login,
  Home,
  PLPrimaryStars,
  PLKicks,
  PLInspires,
  PLPfa,
  Facilities,
  Funding,
  EconomicImpact
  // AboutThePL
}
